export const DEFAULTS = {
    API:"https://raffle-private-inbetweeners.herokuapp.com/"
};

export default DEFAULTS;